module.exports = function (input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof input === 'string') input = JSON.parse(input);
  var vars = input.head.vars;
  var results = input.results.bindings;

  if (vars.length === 1 && options.minimize === true) {
    var varName = vars[0];
    return results.map(function (result) {
      return parseValue(result[varName]);
    }) // filtering-out bnodes
    .filter(function (result) {
      return result != null;
    });
  }

  var _identifyVars = identifyVars(vars),
      richVars = _identifyVars.richVars,
      standaloneVars = _identifyVars.standaloneVars;

  return results.map(getSimplifiedResult(richVars, standaloneVars));
};

var parseValue = function parseValue(valueObj) {
  if (!valueObj) return;
  var datatype = valueObj.datatype;
  datatype = datatype && datatype.replace('http://www.w3.org/2001/XMLSchema#', '');
  var parser = parsers[valueObj.type] || getDatatypesParsers(datatype);
  return parser(valueObj);
};

var parsers = {
  uri: function uri(valueObj) {
    return parseUri(valueObj.value);
  },
  // blank nodes will be filtered-out in order to get things simple
  bnode: function bnode() {
    return null;
  }
};

var numberParser = function numberParser(valueObj) {
  return parseFloat(valueObj.value);
};

var getDatatypesParsers = function getDatatypesParsers(datatype) {
  datatype = datatype && datatype.replace('http://www.w3.org/2001/XMLSchema#', '');
  return datatypesParsers[datatype] || passValue;
};

var datatypesParsers = {
  decimal: numberParser,
  integer: numberParser,
  float: numberParser,
  double: numberParser,
  boolean: function boolean(valueObj) {
    return valueObj.value === 'true';
  } // return the raw value if the datatype is missing

};

var passValue = function passValue(valueObj) {
  return valueObj.value;
};

var parseUri = function parseUri(uri) {
  // ex: http://www.wikidata.org/entity/statement/
  if (uri.match(/http.*\/entity\/statement\//)) {
    return convertStatementUriToGuid(uri);
  }

  return uri // ex: http://www.wikidata.org/entity/
  .replace(/^https?:\/\/.*\/entity\//, '') // ex: http://www.wikidata.org/prop/direct/
  .replace(/^https?:\/\/.*\/prop\/direct\//, '');
};

var convertStatementUriToGuid = function convertStatementUriToGuid(uri) {
  // ex: http://www.wikidata.org/entity/statement/
  uri = uri.replace(/^https?:\/\/.*\/entity\/statement\//, '');
  var parts = uri.split('-');
  return parts[0] + '$' + parts.slice(1).join('-');
};

var identifyVars = function identifyVars(vars) {
  var data = {
    richVars: [],
    standaloneVars: []
  };
  return vars.reduce(spreadVars(vars), data);
};

var spreadVars = function spreadVars(vars) {
  return function (data, varName) {
    if (vars.some(isAssociatedVar(varName))) {
      data.richVars.push(varName);
      return data;
    }

    if (!associatedVarPattern.test(varName)) {
      data.standaloneVars.push(varName);
      return data;
    }

    var associatedVar = varName.replace(associatedVarPattern, '$1') // The pattern regex fails to capture AltLabel prefixes alone,
    // due to the comflict with Label
    .replace(/Alt$/, '');

    if (!vars.includes(associatedVar)) {
      data.standaloneVars.push(varName);
    }

    return data;
  };
};

var associatedVarPattern = /^(\w+)(Label|Description|AltLabel)$/;

var isAssociatedVar = function isAssociatedVar(varNameA) {
  return function (varNameB) {
    if ("".concat(varNameA, "Label") === varNameB) return true;
    if ("".concat(varNameA, "Description") === varNameB) return true;
    if ("".concat(varNameA, "AltLabel") === varNameB) return true;
    return false;
  };
};

var getSimplifiedResult = function getSimplifiedResult(richVars, standaloneVars) {
  return function (result) {
    var simplifiedResult = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = richVars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var varName = _step.value;
        var value = parseValue(result[varName]);

        if (value != null) {
          simplifiedResult[varName] = {
            value: value
          };
          addAssociatedValue(result, varName, 'label', simplifiedResult[varName]);
          addAssociatedValue(result, varName, 'description', simplifiedResult[varName]);
          addAssociatedValue(result, varName, 'aliases', simplifiedResult[varName]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = standaloneVars[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _varName = _step2.value;
        simplifiedResult[_varName] = parseValue(result[_varName]);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return simplifiedResult;
  };
};

var addAssociatedValue = function addAssociatedValue(result, varName, associatedVarName, varData) {
  var fullAssociatedVarName = varName + varNameSuffixMap[associatedVarName];
  var fullAssociatedVarData = result[fullAssociatedVarName];

  if (fullAssociatedVarData != null) {
    varData[associatedVarName] = fullAssociatedVarData.value;
  }
};

var varNameSuffixMap = {
  label: 'Label',
  description: 'Description',
  aliases: 'AltLabel'
};